import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";

import NationalAccount, {
  bankCodeName,
  bankAccountName,
  bankAccountPrefixName,
} from "./nationalAccount";
import RadioGroupItem from "../../../app/generic/form/radioGroupItem";
import InternationalAccount, { ibanFieldName } from "./internationalAccount";

export const nationalName = "national",
  internationalName = "international";

export const parseBankForm = (values) => {
  const prefix = values[bankAccountPrefixName],
    account = values[bankAccountName];
  return {
    prefix: prefix ? prefix.toString() : prefix,
    account: account ? account.toString() : account,
    bank: values[bankCodeName],
    iban: values[ibanFieldName],
  };
};

export const parseInitialBankValues = (bankAccount) => {
  const values = {};
  if (bankAccount) {
    values.accountType = bankAccount.iban ? internationalName : nationalName;
    values[bankAccountPrefixName] =
      bankAccount.prefix && Number.parseInt(bankAccount.prefix);
    values[bankAccountName] =
      bankAccount.account && Number.parseInt(bankAccount.account);
    values[bankCodeName] = bankAccount.bank;
    values[ibanFieldName] = bankAccount.iban;
  }
  return values;
};

export const getDefaultBankForm = () => ({
  accountType: nationalName,
});

const Bank = ({ formItemLayout }) => {
  const [national, setNational] = useState(true);
  const handleTypeChange = useCallback((e) => {
    setNational(e.target.value === nationalName);
  }, []);

  return (
    <>
      <RadioGroupItem
        size="large"
        fieldName="accountType"
        onChange={handleTypeChange}
        formItemLayout={formItemLayout}
        options={[
          {
            id: nationalName,
            name: (
              <FormattedMessage
                id="registration.bank.national"
                defaultMessage="český formát č.ú."
              />
            ),
          },
          {
            id: internationalName,
            name: (
              <FormattedMessage
                id="registration.bank.international"
                defaultMessage="mezinárodní č.ú. - IBAN"
              />
            ),
          },
        ]}
      />
      {national ? (
        <NationalAccount formItemLayout={formItemLayout} />
      ) : (
        <InternationalAccount formItemLayout={formItemLayout} />
      )}
    </>
  );
};

export default Bank;
